/* global angular */

angular.module('AemTransparentAccount')
  .component('firstLetterFrequency', {
    template: require('./first-letter-frequency.component.tpl.html'),
    controller: FirstLetterFrequencyCtrl,
    controllerAs: 'vm',
    bindings: {
      firstLetters: '<'
    }
  })

FirstLetterFrequencyCtrl.$inject = ['$routeParams', '$location']

function FirstLetterFrequencyCtrl ($routeParams, $location) {
  var vm = this

  vm.$onInit = function () {
    vm.isLetterActive = isLetterActive
    vm.selectLetter = selectLetter
  }

  function isLetterActive (letter) {
    return $routeParams.letter === letter
  }

  function selectLetter (letter) {
    if (letter.count) {
      $location.path('/letter/' + letter.letter)
    }
  }
}
